<div class="steps-2 main-category" style="background-image: url({{backGroundImage}});">
  <h2 class="mb-3 mb-md-5">Take the <span class="text-primary">{{categoryData[activeCat]?.name | case}}</span>
    category of the
    Health
    consciousness Assessment</h2>
  <div class="steps-content row">
    
    <div class="steps-count col-md-10">

      <div>
        <div class="avatar-question steps-ques steps-1" *ngIf="categoryData[activeCat]?.questions.length">
          <div class="steps-head">
            <div class="small-text">Select your answer:</div>
            <h3 class="steps-title"><span class="text-primary">{{activeQuestionIndex+1}}.</span>
              {{categoryData[activeCat]?.questions[activeQuestionIndex].question}}
            </h3>
          </div>
          <div class="avatar-answers d-flex flex-col flex-sm-row flex-wrap mt-4">
            <a [class.highlight]="option._id == questonaireData[categoryData[activeCat]?.questions[activeQuestionIndex]._id]"
              role="button"
              (click)="onSelectOption(option._id,categoryData[activeCat]?.questions[activeQuestionIndex]._id)"
              *ngFor="let option of categoryData[activeCat]?.questions[activeQuestionIndex].options;"
              class="mb-4 avatar-answer mr-3 border radius-25 rounded-sm px-5 py-2 d-flex flex-row align-items-center">

              <p class="big ">{{option.option}}</p>
            </a>
          </div>
        </div>

        <div class="actions ">
          <div class="d-flex flex-row align-items-center action-block">
            <button [disabled]="activeQuestionIndex == 0" mat-stroked-button class="custom-button mr-4 back-btn"
              (click)="onClickBack()"><span class="material-icons mr-2">
                keyboard_backspace
              </span>
              <span class="d-inline-block d-md-none ml-2">Previous</span></button>
            <mat-progress-bar mode="determinate" value="{{progress}}" [color]="color" class="d-none d-md-block">
            </mat-progress-bar>
          </div>

        </div>
      </div>

    </div>


  </div>
</div>